<template>
  <button v-bind="$attrs" type="button" class="btn btn_danger btn_small" @click="handleClick">
    <slot/>
    <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
      <icon-cancel/>
    </icon-base>
  </button>
</template>

<script>
export default {
  name: "CancelBtn",
  methods: {
    // Просто дефолтное поведение, чтоб @click работал на компоненте
    handleClick(evt) {
      this.$emit('click', evt);
    }
  },
}
</script>
